import { Accordion } from '../../../../../../common/SharedComponents';
import { ICoreTableRow } from '../common/constants/tables/interfaces/ICoreTableRow';
import { ILoanHistorySummaryTableRow } from '../common/constants/tables/interfaces/ILoanHistorySummaryTableRow';
import { CoreTable } from './components/CoreTable';

interface CoreProps {
    coreData: ICoreTableRow[] | undefined;
    onLoanSummaryClick: (loans: ILoanHistorySummaryTableRow[] | undefined) => void;
}
export const Core: React.FC<CoreProps> = ({ onLoanSummaryClick, coreData }) => {
    return (
        <>
            <Accordion
                title='Core'
                isExpanded={true}
                id={`bll_core`}
                isCollapsable={true}
            >
                <div
                    className='card'
                    style={{ width: '720px', border: '1px solid gray' }}
                >
                    <div className='card-section'>
                        <CoreTable
                            onLoanSummaryClick={onLoanSummaryClick}
                            coreData={coreData}
                        />
                    </div>
                </div>
                <div style={{ fontStyle: 'italic', paddingLeft: '20px', paddingBottom: '20px', color: 'gray', fontSize: '14px' }}>
                    * Amount over $1 MM from Bridge below
                </div>
            </Accordion>
        </>
    );
};
